import { DashboardNodeComponent } from '../../view/dashboard-node.component';
import { Collapse, Layout, Widget } from '../dashboard.node';
import { ComponentType } from '@angular/cdk/overlay';

export interface RegisteredComponent {
  class: ComponentType<DashboardNodeComponent<Layout | Collapse | Widget>>;
  cssClassName: string;
  name: string;
  id: string;
}

export abstract class Components {
  private readonly items = new Map<string, RegisteredComponent>();

  public add(params: RegisteredComponent) {
    if (!params?.id || !params?.name || !params?.class) {
      throw new Error('id, name, and component are required !');
    } else if (!this.exist(params.id)) {
      this.items.set(params.id, params);
    }
  }

  public exist(id: string): boolean {
    return this.items.has(id);
  }

  public get(id: string): RegisteredComponent | undefined {
    return this.items.get(id);
  }
}
